"use strict";

angular.module('PatientApp').controller('VerifyEstimateCtrl', function ($rootScope, $scope, VuexStore) {
  $rootScope.newContent = true;
  var currentEstimate = VuexStore.state.EstimatesStore.currentEstimate;

  if (currentEstimate) {
    $scope.provider = currentEstimate.providerDetails;
  }
});